<template>
  <div class="perfils-isp">
    <div class="form-group">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="handleAdicionar()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
          </button>
        </div>

        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="25">#</th>
              <th>Descrição</th>
              <th>Velocidade</th>
              <th>Tipo</th>
              <th width="120"></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="perfil in listaPerfis" :key="perfil.id">
                <td scope="row">{{perfil.id}}</td>
                <td>{{perfil.descricao}}</td>
                <td>{{perfil.velocidade_kbps}} kbps</td>
                <td>{{perfil.tipo}}</td>
                <td class="text-end">
                  <button type="button" v-on:click="handleEditaPerfilBandaOlt(perfil)" class="btn btn-primary btn-sm me-1">
                    <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                  </button>
                  <button type="button" v-on:click="handleRemovePerfilBandaOlt(perfil)" class="btn btn-danger btn-sm">
                    <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                  </button>
                </td>
              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>
    </div>

    <!-- modal-edita-perfil -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-perfil" id="btn-modal-edita-perfil-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-edita-perfil" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="!modalPerfilBandaOlt.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
              Inserir novo perfil
            </h5>
            <h5 v-if="!!modalPerfilBandaOlt.data.id" class="modal-title">
              <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
              Editando perfil
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 mb-2">
                <label>Descrição</label>
                <input v-model="modalPerfilBandaOlt.data.descricao" type="text" class="form-control">
              </div>

              <div class="col-12 col-sm-6 col-md-4 mb-2">
                <label>Velocidade</label>
                <input v-model.number="modalPerfilBandaOlt.data.velocidade_kbps" type="number" min="0" max="2097152" class="form-control">
              </div>

              <div class="col-12 col-sm-6 col-md-4 mb-2">
                <label>Tipo</label>
                <select v-model="modalPerfilBandaOlt.data.tipo" class="form-select">
                  <option disabled :value="undefined">Selecione</option>
                  <option value="tbDownload">Download</option>
                  <option value="tbUpload">Upload</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-perfil-fecha">Fechar</button>
            <button type="button"
                v-if="!modalPerfilBandaOlt.data.id"
                v-on:click="handleModalPerfilBandaOltCadastrar()"
                v-bind:disabled="!podeSalvarPerfilBandaOlt()"
                class="btn btn-success">
              Cadastrar
            </button>
            <button type="button"
                v-if="!!modalPerfilBandaOlt.data.id"
                v-on:click="handleModalPerfilBandaOltSalvar()"
                v-bind:disabled="!podeSalvarPerfilBandaOlt()"
                class="btn btn-success">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-perfil -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'ServidoresOLTPerfilBanda',

  components: {
    Paginador,
  },

  data() {
    return {
      oltID: undefined,
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaPerfis: [],
      modalPerfilBandaOlt: {
        data: {
          id: undefined,
          descricao: '',
          velocidade_kbps: 0,
          tipo: undefined,
        },
      }
    }
  },

  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/servidores/olt/${this.oltID}/pon-bandwidth?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaPerfis = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    resetModalPerfilBandaOlt() {
      this.modalPerfilBandaOlt.data.id = undefined;
      this.modalPerfilBandaOlt.data.descricao = '';
      this.modalPerfilBandaOlt.data.velocidade_kbps = 0;
      this.modalPerfilBandaOlt.data.tipo = undefined;
    },

    handleAdicionar() {
      this.resetModalPerfilBandaOlt();
      this.abreModalCadastroPerfilBandaOlt();
    },

    handleEditaPerfilBandaOlt(perfilISP) {
      this.resetModalPerfilBandaOlt();
      this.modalPerfilBandaOlt.data = clone(perfilISP);
      this.abreModalCadastroPerfilBandaOlt();
    },

    handleRemovePerfilBandaOlt(perfilISP) {
      dialogo.confirmacao(`Confirma remover o perfil <b>${perfilISP.descricao}</b>?`).then(() => {
        loading(true);

        api.delete(`/servidores/olt-pon-bandwidth/${perfilISP.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroPerfilBandaOlt() {
      document.getElementById('btn-modal-edita-perfil-abre').click();
    },

    podeSalvarPerfilBandaOlt() {
      switch (true) {
        case (this.modalPerfilBandaOlt.data.descricao.length < 2):
        case (this.modalPerfilBandaOlt.data.velocidade_kbps <= 0):
        case (!this.modalPerfilBandaOlt.data.tipo):
          return false;

        default:
          return true;
      }
    },

    handleModalPerfilBandaOltCadastrar() {
      const sendData = clone(this.modalPerfilBandaOlt.data);

      loading(true);

      api.post('/servidores/olt-pon-bandwidth', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-perfil-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handleModalPerfilBandaOltSalvar() {
      const sendData = clone(this.modalPerfilBandaOlt.data);

      loading(true);

      api.put(`/servidores/olt-pon-bandwidth/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-perfil-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },
  },

  created() {
    const oltID = +this.$route.params.oltID;

    if (!oltID) {
      this.$router.push({ path: `/configuracoes/servidores` });
      return;
    }

    this.oltID = oltID;

    this.handlePesquisa();
  }
}
</script>
